import React from 'react';
import CopyrightClient from 'constants/copyrightClient';
import style from './style.module.scss';

const Footer = () => {
  return (
    <div className={style.footer}>
      <div className={style.footerInner}>
        <span className={style.logo}>
          {CopyrightClient[process.env.REACT_APP_CLIENT]}
          <span />
        </span>
        <br />
        <p className='mb-0'>Copyright © {new Date().getFullYear()}</p>
      </div>
    </div>
  );
};

export default Footer;
